import axios from '../../utils/axios';

export const getNftPaginateThunk = async (_, thunkApi) => {
  try {
    const { connectedAccount, chainId, contract } = thunkApi.getState().user;
    const { page, limit } = thunkApi.getState().nft.paginate;
    const res = await axios.get('/nft/paginate', {
      params: {
        page,
        limit,
        owner: connectedAccount,
        chainId,
        contract,
      },
    });
    return res.data;
  } catch (err) {
    return thunkApi.rejectWithValue(err.response.data);
  }
};

export const getNextIdThunk = async (payload, thunkApi) => {
  try {
    const { chainId } = thunkApi.getState().user;
    const { contract } = payload;
    const res = await axios.get('/nft/nextId', {
      params: {
        chainId,
        contract,
      },
    });
    return res.data;
  } catch (err) {
    return thunkApi.rejectWithValue(err.response.data);
  }
};
